import ManualTradeConfig from './ManualTradeConfig';

export default ManualTradeConfig;
